<template>
  <v-dialog v-model="viewNbnAppointment" width="500" persistent>
    <v-card class="pb-4">
      <v-card-title class="primary">
        <span class="white--text"
        >Appointment - {{ appointmentData.id }}</span
        >
      </v-card-title>
      <v-card-text class="subtitle-1 pb-0">
        <v-row>
          <v-col>
            <b>Appointment ID: </b> {{ appointmentData.id }}<br />
            <b>Start Date/Time: </b>
            {{ appointmentData.appointmentSlot.validFor.startDateTime | formatDateTime(true) }}<br />
            <b>End Date/Time: </b>
            {{ appointmentData.appointmentSlot.validFor.endDateTime | formatDateTime(true) }}<br />
            <b>Status: </b> {{ appointmentData.status }}<br />
            <b>Priority Assist: </b> {{ appointmentData.priorityAssist }}<br />
            <b>Appointment SLA: </b> {{ appointmentData.appointmentSLA }}<br />
            <b>End User Type: </b> {{ appointmentData.endUserType }}<br />
            <b>Demand Type: </b> {{ appointmentData.demandType }}<br />
            <b>Location Id: </b> {{ appointmentData.place.id }}<br />
            <b>Primary Access Technology: </b> {{ appointmentData.workZone.primaryAccessTechnology }}<br />
            <b>Serviceability Class: </b> {{ appointmentData.workZone.serviceabilityClass }}<br />
            <b>CSA ID: </b> {{ appointmentData.workZone.csaID }}<br />
            <b>Region: </b> {{ appointmentData.workZone.region }}<br />
            <b>Contact Name: </b> {{ (appointmentData.endUserContact)[0].contactName }}<br />
            <b>Contact Number: </b> {{ (appointmentData.endUserContact)[0].phoneNumber }}<br />
            <b>Contact Name: </b> {{ (appointmentData.endUserContact)[0].contactName }}<br />
            <b>Contact Notes: </b> {{ (appointmentData.endUserContact)[0].notes }}<br />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="pb-0 pt-2">
        <v-row class="mb-2">
          <fancy-button
            :icon="`mdi-restart`"
            :text="`Reschedule`"
            @click="onTriggerReschedule"
            :disabled="rescheduleCount >= 3"
          ></fancy-button>
          <fancy-button
            :icon="`mdi-cancel`"
            :text="`Cancel`"
            @click="onTriggerCancel"
          ></fancy-button>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="mt-4">
        <v-spacer></v-spacer>
        <v-btn @click="$emit('close-appointment')" class="mr-4">Close</v-btn>
      </v-card-actions>
    </v-card>
    <confirm-action
      :dialog="cancelDialog"
      :text="cancelDialogText"
      :proceedText="`Yes`"
      :cancelText="`No`"
      @onBtnClick="onCancelConfirm"
    ></confirm-action>
    <reschedule-nbn-appointment
      :appointmentData="appointmentData"
      :rescheduleNbnAppointment="rescheduleDialog"
      @closeReschedule="rescheduleDialog = false"
      @processNbnReschedule="onProcessReschedule"
    ></reschedule-nbn-appointment>
  </v-dialog>
</template>

<script>
export default {
  name: "view-nbn-appointment",
  props: {
    viewNbnAppointment: {
      type: Boolean,
      required: true,
    },
    appointmentData: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    cancelDialog: false,
    rescheduleDialog: false,
    cancelDialogText: "Are you sure you want to cancel this appointment?",
  }),
  methods: {
    onProcessReschedule(args) {
      let vm = this;
      let payload = {};
      payload = {appointment:{
          externalId:vm.appointmentData.externalId,//todo need to replace this
          place:{id:vm.appointmentData.place.id},
          demandType:vm.appointmentData.demandType,
          endUserType:(vm.appointmentData.endUserType === null || vm.appointmentData.endUserType === undefined || vm.appointmentData.endUserType ==="")?"Residential":vm.appointmentData.endUserType,
          appointmentSLA:vm.appointmentData.appointmentSla,
          priorityAssist:"No",
          appointmentType:"Appointment",
          alternativeTechnology:null,
          endUserContact:[{
            contactType:"Primary Contact",
            contactName:vm.appointmentData.endUserContact.contactName,
            phoneNumber:vm.appointmentData.endUserContact.phoneNumber,
            notes:vm.appointmentData.endUserContact.notes
          }],
          appointmentSlot:{
            appointmentSlotType:args.appointmentSlotType,
            validFor:{
              startDateTime:args.validFor.startDateTime,
              endDateTime:args.validFor.endDateTime,
            }
          }
        },
        id:vm.appointmentData.id
      };


      vm.updateNbnAppointment(payload).then(() => {
        vm.rescheduleDialog = false;
      });
    },
    onTriggerReschedule() {
      let vm = this;
      vm.rescheduleDialog = true;
    },
    onTriggerCancel() {
      let vm = this;
      vm.cancelDialog = true;
    },
    onCancelConfirm(args) {
      let vm = this;
      if (args) {
        let payload = {
          appointmentId: vm.appointmentData.id,
        };

        vm.cancelNbnAppointment(payload).then(() => {
          vm.cancelDialog = false;
        });
      } else vm.cancelDialog = false;
    },
  },
  computed:{
    rescheduleCount(){
      let vm = this;
      let count = 0;
      let keyword = ["resched", "booked"];

      if(vm.appointmentData.appointmentHistory){
        keyword.forEach(x => {
        vm.appointmentData.appointmentHistory.forEach(y => {
          if(y.reasonCodeHistory.code.toLowerCase().includes(x)) count++;
        })
      })
      }

      return count;

    }
  }
}
</script>

<style scoped>

</style>
